<div
  class="no-active-subscription-container horizontal-center back-btn"
  (click)="disabled($event)"
  (keydown)="handleKeydown($event)"
  (mousedown)="disabled($event)"
  (mouseup)="disabled($event)"
>
  <div class="no-active-subscription-modal">
    <h2 [style]="'fontSize.36' | translate">
      {{ 'no_subscription_available' | translate }}
    </h2>
    <p
      [innerHTML]="'free_preview_desc' | translate"
      [style]="'fontSize.28' | translate"
    ></p>
    <div
      class="actions horizontal-as horizontal-focusable-container generic-dialog"
    >
      <app-icon-button
        [label]="'subscribe_now' | translate"
        [mode]="'subscribe'"
        class="subscribe-now-button"
        [isUppercase]="false"
        (clicked)="subscribeNowAction()"
      ></app-icon-button>
      <app-icon-button
        [label]="'may_be_later_title' | translate"
        (clicked)="maybeLaterAction()"
      ></app-icon-button>
    </div>
  </div>
</div>
